exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "page-location {\n  /* HOME */\n  /* END HOME */ }\n  page-location .intro {\n    padding: 160px 1rem; }\n  page-location .intro p {\n    margin-bottom: 0;\n    line-height: 20px;\n    font-size: 1.1rem;\n    font-weight: 300; }\n  page-location .intro form {\n    margin: 30px auto 0;\n    text-align: center;\n    display: block; }\n  page-location .intro .form-control {\n    min-width: 50%;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px; }\n  page-location .intro form .btn {\n    box-shadow: rgba(0, 0, 0, 0.3) 0 1px 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/location/location.scss
// module id = ../../../../../src/app/pages/location/location.scss
// module chunks = main